import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../services/axiosInstance';
import AssessmentSubmittedPopup from '../../components/SubmitAssementPopup';
import { useNavigate } from 'react-router-dom';



const AssessmentPageLoader = () => (
  <div className="bg-white min-h-screen animate-pulse">
    <div className="mx-auto px-4 py-8">
      {/* Header */}
      <div className="h-6 w-40 bg-gray-200 rounded mb-3" />
      <div className="h-4 w-64 bg-gray-200 rounded mb-6" />

      {/* Form Card */}
      <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100">
        {/* Repeat question skeletons */}
        {Array.from({ length: 5 }).map((_, qIdx) => (
          <div key={qIdx} className="mb-8">
            {/* Question title */}
            <div className="h-5 w-3/4 bg-gray-200 rounded mb-4" />

            {/* Options */}
            <div className="space-y-3">
              {Array.from({ length: 4 }).map((__, oIdx) => (
                <div key={oIdx} className="flex items-center gap-3">
                  <div className="w-4 h-4 bg-gray-300 rounded-full" />
                  <div className="h-4 w-2/3 bg-gray-200 rounded" />
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Submit button placeholder */}
        <div className="text-center pt-4">
          <div className="h-10 w-40 bg-gray-300 rounded-lg inline-block" />
        </div>
      </div>
    </div>
  </div>
);


function CourseModuleAssement() {
  const { id } = useParams();
  const [isPageLoading,setIsloading] =  useState(true)
  // ✅ track questions and answers in state
  const [questions, setQuestions] = useState([{id:"",question:"",options:{a:"",b:"",c:"",d:""}}]);
  const [answers, setAnswers] = useState({});
  const [isOpen,setOpen] = useState(false)
  const [result, setResult] = useState({
    status: 'loading',
    comment: (
        <>
          We’re reviewing your assessment.
          <br />
          Please do not refresh or leave this page until the process is complete.
        </>
      )
  });

  

  const navigate = useNavigate();
  
  const redirectToCourse = () => {
      setTimeout(() => {
        navigate('/nurse/adhdcourse');
      }, 3000);
  };

  useEffect(() => {
    const fetchQuestion = async () => {
      try {
        const res = await axiosInstance.get(`/course/module/questions/${id}`);
        setQuestions(res?.data?.data?.Questions)
        setIsloading(false)
      } catch (error) {
        console.error('Error fetching course:', error);
      }
    };

    fetchQuestion();

    // Put your current 3 questions into state so they're stored
    setQuestions([{
        id: '',
        question: "",
        options: []
      }

    ]);
  }, [id]);


  const submitAssement = async (answers) => {
    try {
      const res = await axiosInstance.post(`/course/module/assement/${id}`, { answers });
      setResult(res.data.data)
      redirectToCourse()
    } catch (error) {
      console.error("Error fetching course:", error);
    }
  };
    

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (questions.length !== Object.keys(answers).length) {
        window.alert("Please attempt all the questions");
        return;
      }
    setOpen(true);
    await submitAssement(answers)
  };

  return isPageLoading?(<AssessmentPageLoader/>) : (
  <div className="bg-white min-h-screen">
    <AssessmentSubmittedPopup
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      result={result}
    />
      <div className="mx-auto px-4 py-8">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-6">Assessment</h2>
            <p className="text-gray-600 mb-6">Complete the following questions</p>
            <form
              className="bg-white rounded-lg shadow-md p-6 border border-gray-100"
            >
            {questions.map((q, idx) => {
              const qKey = q?._id;     
              const entries = Object.entries(q?.options ?? {}); 

              return (
                <div className="mb-8" key={qKey}>
                  <h3 className="font-semibold text-gray-800 mb-4">
                    {idx + 1}. {q.question}
                  </h3>

                  <div className="space-y-3">
                  {entries.map(([optKey, label]) => (
                      <label key={`${qKey}-${optKey}`} className="flex items-center gap-3 cursor-pointer">
                        <input
                          type="radio"
                          name={`q-${qKey}`}
                          value={optKey}
                          checked={answers[qKey] === optKey} 
                          onChange={() =>
                            setAnswers(prev => ({ ...prev, [qKey]: optKey }))
                          }
                          className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">
                          {String(optKey).toUpperCase()}. {label}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              );
            })}
            <div className="text-center pt-4">
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white font-medium px-8 py-3 rounded-lg transition-colors duration-200"
                onClick={handleSubmit}
              >
                Submit Test
              </button>
            </div>
            </form>
          </div>
      </div>
    </div>
  );
}

export default CourseModuleAssement;
